<template>
    <div class="ord">
        <router-view></router-view>
    </div>

</template>

<script>

    export default {
        name: 'OrderManagement',
    }
</script>
